import { render } from "./CopyTextComponent.vue?vue&type=template&id=251b1fb1&scoped=true"
import script from "./CopyTextComponent.vue?vue&type=script&lang=js"
export * from "./CopyTextComponent.vue?vue&type=script&lang=js"

import "./CopyTextComponent.vue?vue&type=style&index=0&id=251b1fb1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251b1fb1"]])

export default __exports__